export default {
  componentName: 'final-results-component.jsx, final-results-day-component.jsx',
  exampleImgUrl:
    'https://drive.google.com/open?id=1lIR3U4UNzF2CTLSItLzjYu5TI2_SGZYL',
  nickname: '(Rendered dynamically in component)',
  pageList: [
    'https://www.bassmaster.com/results/tournaments/2018-stlawrence-elite/1',
    'https://www.bassmaster.com/results/tournaments/2018-stlawrence-elite/1?day=3',
  ],
  renderId: 'react-app--final-results, react-app--final-results-day',
};
